export var RelationshipWithGroup;
(function (RelationshipWithGroup) {
    RelationshipWithGroup["NONE"] = "NONE";
    RelationshipWithGroup["JOINED"] = "JOINED";
    RelationshipWithGroup["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    RelationshipWithGroup["REJECTED_MEMBERSHIP"] = "REJECTED_MEMBERSHIP";
})(RelationshipWithGroup || (RelationshipWithGroup = {}));
export var RoleInGroup;
(function (RoleInGroup) {
    RoleInGroup["GROUP_ADMIN"] = "GROUP_ADMIN";
    RoleInGroup["GROUP_MEMBER"] = "GROUP_MEMBER";
    RoleInGroup["SITE_ADMIN"] = "SITE_ADMIN";
})(RoleInGroup || (RoleInGroup = {}));
export var GroupPrivacyLevel;
(function (GroupPrivacyLevel) {
    GroupPrivacyLevel["SECRET"] = "SECRET";
    GroupPrivacyLevel["PRIVATE"] = "PRIVATE";
    GroupPrivacyLevel["PUBLIC"] = "PUBLIC";
})(GroupPrivacyLevel || (GroupPrivacyLevel = {}));
export var Type;
(function (Type) {
    Type["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    Type["PAID_PLANS"] = "PAID_PLANS";
    Type["EVENTS"] = "EVENTS";
})(Type || (Type = {}));
export var GroupApprovalStatus;
(function (GroupApprovalStatus) {
    GroupApprovalStatus["EMPTY"] = "EMPTY";
    GroupApprovalStatus["PENDING"] = "PENDING";
    GroupApprovalStatus["APPROVED"] = "APPROVED";
    GroupApprovalStatus["REJECTED"] = "REJECTED";
    GroupApprovalStatus["CANCELLED"] = "CANCELLED";
})(GroupApprovalStatus || (GroupApprovalStatus = {}));
export var GroupsSortBy;
(function (GroupsSortBy) {
    GroupsSortBy["RECENT_ACTIVITY"] = "RECENT_ACTIVITY";
    GroupsSortBy["NAME"] = "NAME";
    GroupsSortBy["MEMBERS_COUNT"] = "MEMBERS_COUNT";
})(GroupsSortBy || (GroupsSortBy = {}));
export var CreateGroupsPolicy;
(function (CreateGroupsPolicy) {
    CreateGroupsPolicy["ONLY_ME"] = "ONLY_ME";
    CreateGroupsPolicy["MEMBERS"] = "MEMBERS";
    CreateGroupsPolicy["MEMBERS_WITH_MY_APPROVAL"] = "MEMBERS_WITH_MY_APPROVAL";
})(CreateGroupsPolicy || (CreateGroupsPolicy = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map